import { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/feedback/PageHeader';
import { ScrollPage } from '@/components/layout/PageContainer';
import { useTtsFlowDetail } from '../api';
import { hydrateTtsFlowFromDetail } from '../payload';
import { StepReview } from '../components/steps/StepReview';
import { DEFAULT_TTS_FORM_VALUES, type TtsFlowFormValues } from '../types';

export function ViewTtsFlowPage() {
  const { ttsFlowId } = useParams<{ ttsFlowId: string }>();
  const id = Number(ttsFlowId);
  const detail = useTtsFlowDetail(id);

  const values = useMemo<TtsFlowFormValues | null>(() => {
    if (!detail.data) return null;
    return { ...DEFAULT_TTS_FORM_VALUES, ...hydrateTtsFlowFromDetail(detail.data) };
  }, [detail.data]);

  if (detail.isLoading || !values) {
    return (
      <div className="flex h-full items-center justify-center gap-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        Loading TTS flow…
      </div>
    );
  }

  return (
    <ScrollPage>
      <PageHeader
        title={`View TTS Flow — ${values.ttsFlowName || `#${id}`}`}
        description="Read-only view of this TTS flow configuration."
        actions={
          <Button asChild variant="outline">
            <Link to="/tts-flow-list">
              <ArrowLeft className="h-4 w-4" />
              Back to TTS flows
            </Link>
          </Button>
        }
      />
      <StepReview values={values} setValues={() => {}} />
    </ScrollPage>
  );
}
